import styled from 'styled-components';

export const Root = styled.div`
  position: absolute;
  ${props => (props.readOnly ? 'top: 15px;' : 'top: -15px;')} right: 30px;
`;

export const Button = styled.button`
  color: ${props => props.theme.color.brand.white};
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  font-family: ${props => props.theme.font.brand.primary};
  font-size: 2.5rem;

  background: ${props => props.theme.color.brand.accent};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  outline: none;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 90px;
`;
